import { render, staticRenderFns } from "./RestaurantSearchSlider.vue?vue&type=template&id=fc3ab7f4&scoped=true&"
import script from "./RestaurantSearchSlider.vue?vue&type=script&lang=js&"
export * from "./RestaurantSearchSlider.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantSearchSlider.vue?vue&type=style&index=0&id=fc3ab7f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3ab7f4",
  null
  
)

export default component.exports